<template>
<div class='donut-widget'>
  <div class='donut-chart'>
    <donut-chart
      :series='valuesForChart'
      :colors='colorsForChart'
      :showTotal=showTotal
    />
  </div>
  <v-divider vertical class='divider'/>
  <div :class="['widget-values', { 'widget-values--scrollable': values.length > 0 }]">
    <LegendWidgetCell
    v-for='(label, index) in labels' :key='index'
    :value='values[index]'
    :color='colorsFormatted[index]'
    :label='label'
    ></LegendWidgetCell>
    <div v-if='values.length === 0'>
      <lottie-animation
        ref="anim"
        :animationData="require('@/assets/icons/animations/ghost.json')"
        :loop="true"
        :style="'height: 200px'"
      />
    </div>
  </div>
</div>
</template>

<script>
import LegendWidgetCell from '@/components/Dashboard/LegendWidgetCell.vue';
import DonutChart from '@/components/common/DonutChart.vue';
import LottieAnimation from 'lottie-web-vue';

export default {
  name: 'DonutWidget',
  props: {
    values: {
      required: true,
      type: Array,
    },
    labels: {
      required: true,
      type: Array,
    },
    colors: {
      type: Array,
      default: () => ['#DF399F', '#682FD2', '#FF952C', '#00D0C4'],
    },
    showTotal: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DonutChart,
    LegendWidgetCell,
    LottieAnimation,
  },
  computed: {
    valuesForChart() {
      if (this.values.some(item => item > 0)) {
        return this.values.filter(item => item !== 0);
      }
      return this.values.map(item => (item > 0 ? item : 1));
    },
    colorsForChart() {
      const newColors = [];
      this.values.forEach((value, index) => {
        if (value !== 0) {
          newColors.push(this.colors[index]);
        }
      });
      return newColors.length > 0 ? newColors : this.colorsFormatted;
    },
    colorsFormatted() {
      const currentColors = this.colors;
      const diff = this.values.length - this.colors.length;
      if (diff > 0) {
        for (let i = 0; i < diff; i += 1) {
          let randomColor = Math.floor(Math.random() * 16777215).toString(16);
          while (currentColors.includes(randomColor)) {
            randomColor = Math.floor(Math.random() * 16777215).toString(16);
          }
          currentColors.push(`#${randomColor}`);
        }
      } else if (diff < 0) {
        currentColors.slice(diff * -1);
      }
      return currentColors;
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.donut-widget {
  display: flex;
  min-height: rem(215);
  max-height: rem(215);
  overflow: hidden;
  align-items: center;
  background-color: var(--bg-widget);
  border-radius: $radius-md;
  .donut-chart{
    max-width: rem(230);
  }
  .widget-values {
    margin-left: rem(5);
    margin-right: rem(5);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: left;
    max-height: rem(208);
    overflow: hidden;
    &--scrollable {
      overflow-y: auto;
    }
  }
}
</style>
<style lang="scss">
@import '~@/assets/styles/design-system';
.donut-widget {
  .v-divider {
    margin: rem(26) rem(25);
  }
}
</style>
